import React, { useCallback } from "react";
import { BottomNav } from "./bottom-nav";
import { MobileHeader } from "./mobile-header";

interface AppLayoutProps {
  children: React.ReactNode;
  title?: string;
  backPath?: string;
  rightContent?: React.ReactNode;
  headerIcon?: React.ReactNode;
  showHeader?: boolean;
  transparentHeader?: boolean;
  className?: string;
  headerClassName?: string;
  contentClassName?: string;
}

export function AppLayout({
  children,
  title,
  backPath,
  rightContent,
  headerIcon,
  showHeader = true,
  transparentHeader = false,
  className = "",
  headerClassName = "",
  contentClassName = "",
}: AppLayoutProps) {
  

  return (
    <div className={`min-h-screen flex flex-col ${className}`}>
      {showHeader && title && (
        <MobileHeader
          title={title}
          backPath={backPath}
          rightContent={rightContent}
          icon={headerIcon}
          transparent={transparentHeader}
          className={headerClassName}
        />
      )}

        <main className={`flex-1 pb-20 ${contentClassName}`}>{children}</main>

      <BottomNav />
    </div>
  );
}